var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 157,
    viewBox: "0 0 390 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-16.6062 147.213L-47.6759 108.21C-56.6765 96.8705 -54.134 80.344 -42.2349 72.1062C25.193 25.4253 106.147 0 188.525 0C270.903 0 351.858 25.4253 419.235 72.1062C431.134 80.344 433.727 96.8705 424.676 108.21L393.606 147.213C385.521 157.332 370.977 159.671 360.299 152.399C309.652 117.77 250.716 99.5656 188.525 99.5656C126.335 99.5656 67.3991 117.77 16.7518 152.399C6.07319 159.722 -8.47009 157.332 -16.5553 147.213H-16.6062Z",
    fill: "#0D968F",
    fillOpacity: 0.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopShape);
export default __webpack_public_path__ + "static/media/top-shape.d4ea4f93f54b9678056d0425ec0fc1bd.svg";
export { ForwardRef as ReactComponent };